class DynamicLinkAddPageController {

  constructor(DynamicLinkService, AlertService, LoaderService, $state, Upload) {
    this.AlertService = AlertService;
    this.DynamicLinkService = DynamicLinkService;
    this.LoaderService = LoaderService;
    this.$state = $state;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    self.newDynamicLink = angular.copy(self.DynamicLinkService.getNew());
    self.files = [];
    self.validation = {};
  }

  storeFile(picFile) {
    this.files[0] = picFile;
  }

  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.DynamicLinkService.addNew(self.newDynamicLink, self.files[0])
      .then(() => {
        // empty the file array
        self.files.splice(0, self.files.length);
        self.AlertService.success("New dynamic link has been added");
        self.$state.go('app.moreItems.dynamicLinks', {}, { reload: true });
      }
      )
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          self.validation.headerImage = error.message;
          self.AlertService.error("The form has validation errors.");
        }
        else {
          self.AlertService.error("There was a problem saving the dynamic link");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.newDynamicLink.name === undefined || self.newDynamicLink.name === '') {
      self.validation.name = 'Name is required';
    }
    if (self.newDynamicLink.url === undefined || self.newDynamicLink.url === '') {
      self.validation.url = 'URL is required';
    } else if (self.newDynamicLink.url.length > 0 && !self.newDynamicLink.url.startsWith("http://") && !self.newDynamicLink.url.startsWith("https://")) {
      self.validation.url = 'Please ensure URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {

    // null and undefined are "empty"
    if (obj == null) return true;

    // Assume if it has a length property with a non-zero value
    // that that property is correct.
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;

    // If it isn't an object at this point
    // it is empty, but it can't be anything *but* empty
    // Is it empty?  Depends on your application.
    if (typeof obj !== "object") return true;

    // Otherwise, does it have any properties of its own?
    // Note that this doesn't handle
    // toString and valueOf enumeration bugs in IE < 9
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }

    return true;
  }

}
DynamicLinkAddPageController.$inject = ['DynamicLinkService', 'AlertService', 'LoaderService', '$state', 'Upload'];
export default DynamicLinkAddPageController;
